import { Page } from '@/components/page';
import { StripePaymentMethod } from '@/components/stripe-payment-method';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { usePlanCreatePaymentIntent } from '@/hooks/plans/use-plan-payment-intent';
import { useEffect, useState } from 'react';
import { useUserPaymentMethods } from '@/hooks/user/use-user-payment-methods';
import { PaymentMethod } from '@/components/payment-method';
import { LoadingScreenSpinner } from '@/components/loading-screen-spinner';

const stripePromise = import.meta.env.VITE_STRIPE_PUBLIC_KEY
  ? loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY)
  : null

export function AddPaymentMethod() {
  const [clientSecret, setClientSecret] = useState<string>();
  const createPaymentIntent = usePlanCreatePaymentIntent();
  const { data: paymentMethods, isLoading: loadingPaymentMethods } = useUserPaymentMethods();

  useEffect(() => {
    const asyncCreatePaymentIntent = async () => {
  
      const response = await createPaymentIntent.mutateAsync();

      setClientSecret(response.clientSecret);
    }

    asyncCreatePaymentIntent();
  }, []);

  if (!clientSecret) {
    return (
      <div className="flex items-center justify-center h-screen mt-[-64px]">
        <div className="flex-1">
          <LoadingScreenSpinner />
        </div>
      </div>
    )
  }

  const options = {
    clientSecret: clientSecret,
    appearance: {/*...*/},
  };

  return (
    <Page title="Billing">
      {paymentMethods && paymentMethods.length > 0 && (
        <div className="bg-white shadow sm:rounded-lg mb-6">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-base font-semibold text-gray-900">Payment methods</h3>
            {paymentMethods?.map((method) => {
              return (
                <div className="mt-5" key={method.id}>
                  <PaymentMethod method={method} />
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-base font-semibold text-gray-900 mb-4">Add payment method</h3>
          <Elements stripe={stripePromise} options={options}>
            <StripePaymentMethod />
          </Elements>
        </div>
      </div>
    </Page>
  );
}